import React, { useEffect } from "react";
import useCurrentEnvironment from "../hooks/use-environment";
import useAccountMetadata from "../hooks/useAccountMetadata";
import firebase from "firebase/app";
import useFeatureFlags from "../hooks/useFeatureFlag";

const FreshChat: ({}: {}) => void = ({}) => {
  const accountMetadata = useAccountMetadata();
  const currentEnvironment = useCurrentEnvironment();
  const flag = useFeatureFlags();
  const user = firebase.auth().currentUser;

  function updateUserProperties(user, currentEnvironment) {
    let widget = (window as any).fcWidget;
    widget.setExternalId(user.uid);
    widget.user.setFirstName(user.displayName);
    widget.user.setEmail(user.email);
    widget.user.setProperties({
      envId: currentEnvironment.ID,
    });
  }

  useEffect(() => {
    if (flag("chatSupport") && user) {
      const id = "freshchat-script";

      if ((window as any).fcWidget) {
        updateUserProperties(user, currentEnvironment);
      }

      if (document.getElementById(id) || (window as any).fcWidget) return;

      const script = document.createElement("script");
      script.src = "//fw-cdn.com/3724785/3134018.js";
      script.type = "text/javascript";
      script.id = id;
      script.async = true;
      document.head.append(script);

      const interval = setInterval(() => {
        if ((window as any).fcWidget) {
          clearInterval(interval);
          updateUserProperties(user, currentEnvironment);
        }
      }, 1000);
    }
  }, [accountMetadata, user, currentEnvironment]);
  return null;
};

export { FreshChat };
